// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Delimiter__delimiter___bxNqi {
    --delimiter-size: var(--space-m);

    display: block;
    align-self: center;

    width: 0.1rem;
    height: var(--delimiter-size);

    border-right: 0.1rem solid var(--color-bg-border);

    &.Delimiter__horizontal___Ygm5i {
        width: var(--delimiter-size);
        height: 0.1rem;
        border-right: 0;
        border-bottom: 0.1rem solid var(--color-bg-border);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Delimiter/Delimiter.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;;IAEhC,cAAc;IACd,kBAAkB;;IAElB,aAAa;IACb,6BAA6B;;IAE7B,iDAAiD;;IAEjD;QACI,4BAA4B;QAC5B,cAAc;QACd,eAAe;QACf,kDAAkD;IACtD;AACJ","sourcesContent":[".delimiter {\n    --delimiter-size: var(--space-m);\n\n    display: block;\n    align-self: center;\n\n    width: 0.1rem;\n    height: var(--delimiter-size);\n\n    border-right: 0.1rem solid var(--color-bg-border);\n\n    &.horizontal {\n        width: var(--delimiter-size);\n        height: 0.1rem;\n        border-right: 0;\n        border-bottom: 0.1rem solid var(--color-bg-border);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delimiter": `Delimiter__delimiter___bxNqi`,
	"horizontal": `Delimiter__horizontal___Ygm5i`
};
export default ___CSS_LOADER_EXPORT___;
